import definition from './history.service';

/**
 * HistoryApi settings
 * @type {{name: string, definition: HistoryApi}}
 */
export default {
    name: 'HistoryApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/history/index.js